import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styles from './input.module.scss';
import classnames from 'classnames';
import { ReactComponent as Closed } from 'assets/icons/closedEye.svg';
import { ReactComponent as Opened } from 'assets/icons/openedEye.svg';

const FormInput = (props) => {
  const {
    label,
    type = 'text',
    name,
    value,
    placeholder,
    onChange,
    onFocus,
    onBlur,
    className,
    disabled,
    id,
    children,
    dataTestId,
    pattern,
    onKeyUp,
    defaultValue
  } = props;

  const [formType, setFormType] = useState(type);

  return (
    <>
      <label className={(styles.input__label, styles[`${type}`], className)} htmlFor={id}>
        {(label || children) && (
          <span className={styles.input__label}>
            {children}
            {label}
          </span>
        )}
        <input
          type={formType}
          value={value}
          onChange={onChange}
          name={name}
          disabled={disabled}
          onFocus={onFocus}
          onKeyUp={onKeyUp}
          onBlur={onBlur}
          className={classnames(styles.input)}
          placeholder={placeholder}
          data-testid={dataTestId}
          pattern={pattern}
          defaultValue={defaultValue}
        />
        {type === 'password' && (
          <button
            className={styles.input__btn}
            type="button"
            aria-label="show password"
            onClick={() => setFormType(formType === 'password' ? 'text' : 'password')}
          >
            {type === 'password' && (
              <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg">
                {formType === 'password' ? <Closed /> : <Opened />}
              </svg>
            )}
          </button>
        )}
      </label>
    </>
  );
};

FormInput.defaultProps = {
  type: null
};

FormInput.propTypes = {
  label: PropTypes.string,
  type: PropTypes.string,
  value: PropTypes.string,
  name: PropTypes.string,
  placeholder: PropTypes.string,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  onFocus: PropTypes.func,
  children: PropTypes.string,
  className: PropTypes.string,
  id: PropTypes.string,
  disabled: PropTypes.bool,
  dataTestId: PropTypes.string,
  pattern: PropTypes.string,
  onKeyUp: PropTypes.string,
  defaultValue: PropTypes.string
};

export default FormInput;
